import { useEffect } from 'react';
import useAccess from '../../hooks/useAccess';
import TRCPendingPage from './Pending';
import TRCRequestPage from './Request';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '@/component/loading';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';

const TRCAccessPage = () => {
	const { hasAccess, isPending, needsAccess, loading, initialLoad } = useAccess();
	const navigate = useNavigate();
	useEffect(() => {
		if (hasAccess) {
			navigate(TRC_ROUTES.TRC_HOME);
		}
	}, [hasAccess]);

	if (loading || initialLoad) return <LoadingPage />;
	return (
		<div
			className="w-100 d-flex justify-content-center align-items-center pt-5 pt-md-0"
			style={{ backgroundColor: '#171718', minHeight: '100svh' }}
		>
			<div className="container-md w-100 d-flex flex-column justify-content-center align-items-center">
				{needsAccess && <TRCRequestPage />}
				{isPending && <TRCPendingPage />}
			</div>
		</div>
	);
};

export default TRCAccessPage;
